import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { AppService } from '../services/app.service';

@Injectable({
    providedIn: 'root'
})
export class isNotBetaGuard implements CanActivate, CanActivateChild {
	constructor(private appService: AppService, 
				private router: Router) {}

    canActivate(): boolean { 
		
		if(this.appService.isBeta)
			this.router.navigate(['/fail/beta']);

		return !this.appService.isBeta;
	}

	canActivateChild(): boolean { return this.canActivate(); }
}